<template>
    <div>
        <QBtn
            color="primary"
            noCaps
            outline
            icon="add_circle_outline"
            :label="$t('invitations.new')"
            class="full-width q-mb-md"
            @click="$emit('create')"
        />

        <q-expansion-item
            icon="info"
            :label="$t('general.info')"
            defaultOpened
            class="ContextDrawerExpansion ContextDrawerExpansion--last"
            header-class="ContextDrawerExpansionHeader"
        >
            <div class="ContextDrawerExpansionContent">
                <div
                    v-if="availableInvitations || availableInvitations === 0"
                    class="flex row-left-center"
                >
                    <q-icon
                        name="info"
                        size="18px"
                        color="primary"
                        class="mr-0-5"
                    />
                    <div class="text-body2 text-weight-bold">
                        {{ availableInvitations }}
                        <span class="text-caption q-ml-xs">
                            {{ $t('invitations.available') }}
                        </span>
                    </div>
                </div>
            </div>
        </q-expansion-item>
    </div>
</template>

<script>
export default {
    name: 'OrganizationInvitationsDrawerPanel',
    props: {
        availableInvitations: {
            type: Number,
            default: undefined,
        },
    },
    emits: ['create'],
}
</script>

<style scoped lang="scss">
:deep(.ContextDrawerExpansion) {
    border-top: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansion.ContextDrawerExpansion--last) {
    border-bottom: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansionHeader .q-item__label) {
    font-weight: 700;
}

:deep(.ContextDrawerExpansionHeader .q-item__section--avatar .q-icon) {
    color: $primary;
}

.ContextDrawerExpansionContent {
    padding: 8px 16px 16px;
}
</style>
